import React, { useEffect, useState } from "react";
// import CommonSelect from "./CommonSelect";
import { Option } from "../license-registration-form/index";

import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { getSSODetailsByLogin, submitBasicDetailsforPanel } from "../../auth/services/privateapicalling";
import { setApplicationId, setUserDet } from "../../../core/data/redux/authSlice";
import CommonSelect from "../license-registration-form/CommonSelect";
import MultiSelectCheckbox from "../../ApplicationsPannelEngineer/PanelMultiSelectCheckbox";
import Select from "react-select";
import borderDistrictData from './borderDistrict.json';
import CommonSelectTwo from "../license-registration-form/commonselectTow";
import { toast, ToastContainer } from "react-toastify";


interface BasicDetailsProps {
  districtOptions: any[];
    talukaOptionsCurr:Option[];
    districtAddressOptions?:Option[];
  talukaOptionsReg:Option[];
   selectData: { district: string; taluka: string };
    setSelectData: React.Dispatch<React.SetStateAction<{ district: string; taluka: string , addressToUpdate:string}>>;
  onNext: (data: any) => void;
  existData:any
   fetchAllDistrictTaluka: (
    token: string,
    district?: string,
    taluka?: string,
    toUpdateDistOpt?: string
  ) => Promise<Option[]>;
  // onPrev: () => void;
  isAllowed:boolean;
  isBasicDetailFilled:boolean;
}



const BasicDetails: React.FC<BasicDetailsProps> = ({ districtOptions, onNext  ,fetchAllDistrictTaluka,talukaOptionsCurr,talukaOptionsReg,selectData,districtAddressOptions,setSelectData, existData , isAllowed , isBasicDetailFilled }) => {

  const token = useSelector((state:any)=>state.auth.token)
  const userDetails = useSelector((state:any)=>state.auth.userDetails)

  const dispatch = useDispatch();

  const language = useSelector((state:any)=>state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage)

  const [populateData, setPopulateData] = useState(null)

  const [isPartnership, setIsPartnership] = useState<string>("");
  const [partners, setPartners] = useState<{ partnerName: string; partnerAge: string; partnerAddress: string }[]>([]);
  const [partnerData, setPartnerData] = useState({ partnerName: "", partnerAge: "", partnerAddress: "" });
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isValid, setIsValid] = useState(false);
  const [borderDistrictOptions, setBorderDistrictOptions] = useState([]);

  const [formData, setFormData] = useState({
    applicantName: existData && "applicantName" in existData ? existData.applicantName : "",
    district: existData && "department" in existData ? existData?.department?.Department_Idetifier : "",
    secondaryDistrict: existData && "borderDepartmentIdentifier" in existData ? existData?.borderDepartmentIdentifier.map(data=>data.Department_Idetifier) : [] ,
    selectedDistrictType: existData?.departmentSelectType ?? "singleDistrict",
    currAt: existData && "perAddress" in existData ? existData.perAddress.at : "",
    currPost: existData && "perAddress" in existData ? existData.perAddress.post : "",
    currTaluka: existData && "perAddress" in existData ? existData.perAddress.taluka : "",
    currDistrict: existData && "perAddress" in existData ? existData.perAddress.district : "",
    regAt: existData && "regOffAddress" in existData ? existData.regOffAddress.at : "",
    regPost: existData && "regOffAddress" in existData ? existData.regOffAddress.post : "",
    regTaluka: existData && "regOffAddress" in existData ? existData.regOffAddress.taluka : "",
    regDistrict: existData && "regOffAddress" in existData ? existData.regOffAddress.district : "",
    registeredEmail: existData && "regEmailId" in existData && existData.regEmailId !== "" ? existData.regEmailId : userDetails.EMAIL,
    mobileNo: existData && "mobileNo" in existData && existData.mobileNo !== "" ? existData.mobileNo : userDetails.MOBILE,
    dob: existData && "dob" in existData ? existData.dob : "",
  });

  
  useEffect(() => {
    if (populateData) {
      setFormData(prev => ({
        ...prev,
        // Only populate if the field is empty (no existData)
        applicantName: prev.applicantName || populateData?.FullName || "",
        currDistrict: prev.currDistrict || populateData?.CurrentDistrictName || "",
        currTaluka: prev.currTaluka || populateData?.CurrentTalukaName || "",
        currAt: prev.currAt || populateData?.CurrentHouseNameNo || "",
        regDistrict: prev.regDistrict || populateData?.PermanentDistrictName || "",
        regTaluka: prev.regTaluka || populateData?.PermanentTalukaName || "",
        regAt: prev.regAt || populateData?.PermanentHouseNoName || "",
      }));
    }
  }, [populateData]);
  
  // Keep the fetchSSODetails useEffect
  useEffect(() => {
    fetchSSODetails()
  }, []) 

  const [addressCheckboxChecked, setAddressCheckboxChecked] = useState(false);

  const today = new Date();
const minAge = 18;
const minDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate()); 



  const [errors, setErrors] = useState<Record<string, string>>({});
  const [loading , setLoading] = useState(false)
  

  // Handle form input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  // Handle dropdown change
  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setIsPartnership(e.target.value);
    if(e.target.value=="No")
      setPartnerData({ partnerName: "", partnerAge: "", partnerAddress: "" });
    setPartners([]);
   
  };
 const handleAddress = async (name: string, option: Option | null, id?: string, toUpdate?: string) => {

 
   if (name === "currDistrict" || name === "perDistrict" || name === "regDistrict") {
     const newDistrictId = option?.value || '';
     const newDistrictValue = option?.label || '';
 
     const taluka = name === "currDistrict" ? "currTaluka" : name === "perDistrict" ? "perTaluka" : "regTaluka";
  
 
     // Update form data first
     setFormData((prev) => ({
       ...prev,
       [name]: newDistrictValue,
       [id]: newDistrictId,
       [taluka]: ""
     }));
 
     // Fetch talukas immediately with the new district
     if (newDistrictId) {
       await fetchAllDistrictTaluka(token, newDistrictId, '', toUpdate);
     }
   }
   else if (name === "currTaluka" || name === "perTaluka" || name === "regTaluka") {
     const newTalukaId = option?.value || '';
     const newTalukaValue = option?.label || '';
 
   
 
     setFormData((prev) => ({
       ...prev,
       [name]: newTalukaValue,
       [id]: newTalukaId
     }));
 
     // Fetch APMCs if needed
     const districtField = name === "currTaluka" ? "currDistrictId" : 
                          name === "perTaluka" ? "perDistrictId" : "regDistrictId";
     const districtId = formData[districtField];
     
     if (districtId && newTalukaValue) {
       await fetchAllDistrictTaluka(token, districtId, newTalukaValue, toUpdate);
     }
   }
 };
  // Handle partner input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPartnerData({ ...partnerData, [name]: value });

    // Clear error when user starts typing
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {

  
    setFormData((prev) => ({
      ...prev,
      selectedDistrictType: event.target.value,
      secondaryDistrict: event.target.value === "multipleDistrict" ? prev.secondaryDistrict : [],
    }));
  
  
  };

  useEffect(() => {
   
  }, [formData.selectedDistrictType]); 
  

  const validatePartnerForm = async () => {
    try {
      const partnerSchema = Yup.object().shape({
        partnerName: Yup.string().trim().matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed").required("Name is required.").max(30),
        partnerAge: Yup.number()
  .typeError("Age must be a number.")
  .positive("Age must be a positive number.")
  .integer("Age must be an integer.")
  .max(120, "Age cannot exceed 120 years.") // Adjust max limit as needed
  .required("Age is required."),
        partnerAddress: Yup.string()
        .trim()
        .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets, numbers, spaces, commas, periods, hyphens, and slashes are allowed.")
        .required("Address is required.")
        .max(50, "Address cannot exceed 50 characters"),
      });
  
      await partnerSchema.validate(partnerData, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = {};
        err.inner.forEach((error) => {
          if (error.path) {
            errorMessages[error.path] = error.message;
          }
        });
        setErrors(errorMessages);
      }
      return false;
    }
  };

  // Add partner entry
  const addPartner = async() => {
    
    const isValid = await validatePartnerForm();
   
      if(isValid)
      {
        setPartners([...partners, partnerData]);

      }
    
      setPartnerData({ partnerName: "", partnerAge: "", partnerAddress: "" });

  
  };

  useEffect(() => {
    
    setIsValid(true);

  }, [partners]);

  // Delete partner entry
  const deletePartner = (index: number) => {
    setPartners(partners.filter((_, i) => i !== index));
  };

  const validationSchema = Yup.object().shape({
    applicantName: Yup.string()
      .trim().matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed")
      .min(3, "Applicant Name must be at least 3 characters")
      .max(30, "Applicant Name must not exceed 30 characters")
      .required("Applicant Name is required"),
  
    district: Yup.string()
      .required("District is required"),

      secondaryDistrict: Yup.array()
      .when("selectedDistrictType", {
        is: "multipleDistrict",
        then: (schema) =>
          schema
            .min(1, "At least one secondary district is required when selecting 'Border Districts'")
            .required("Secondary district is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

  
    isPartnership: Yup.string()
      .oneOf(["Yes", "No"], "Invalid selection")
      .required("This field is required"),
  
      partners: Yup.array()
  .when("isPartnership", {
    is: "Yes",
    then: (schema) =>
      schema.min(1, "At least one partner must be added"),
    otherwise: (schema) =>
      schema
        .default(() => [])
        .test(
          "is-empty-array",
          "Partners must be an empty array when isPartnership is No",
          (value) => value === undefined || (Array.isArray(value) && value.length === 0)
        ),
  }),

      currAt: Yup.string()
      .trim()
      .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets, numbers, spaces, commas, periods, hyphens, and slashes are allowed.")
      .required("Current Address is required.")
      .max(50, "Address cannot exceed 50 characters"),
      currPost: Yup.string().required("Current Address (Post) is required")
      .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Post must contain only letters and spaces")
      .max(20, "Current Address (Post) cannot exceed 20 characters"),
      currTaluka: Yup.string().required("Current Address (Taluka) is required")
      .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Taluka must contain only letters and spaces")
      .max(20, "Current Address (Taluka) cannot exceed 20 characters"),
      currDistrict: Yup.string().required("Current Address (District) is required")
      .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "District must contain only letters and spaces")
      .max(20, "Current Address (District) cannot exceed 20 characters"),
    
      regAt: Yup.string()
      .trim()
      .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Only alphabets, numbers, spaces, commas, periods, hyphens, and slashes are allowed.")
      .required("Registered Office Address is required.")
      .max(50, "Address cannot exceed 50 characters"),
      regPost: Yup.string().required("Registered Office Address (Post) is required")
      .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Post must contain only letters and spaces")
      .max(20, "Registered Office Address (Post) cannot exceed 20 characters"),
      regTaluka: Yup.string().required("Registered Office Address (Taluka) is required")
      .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "Taluka must contain only letters and spaces")
      .max(20, "Registered Office Address (taluka) cannot exceed 20 characters"),
      regDistrict: Yup.string().required("Registered Office Address (District) is required")
      .matches(/^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/, "District must contain only letters and spaces")
      .max(20, "Registered Office Address (district) cannot exceed 20 characters"),
    
      // registeredEmail: Yup.string()
      // .email("Invalid email format")
      // .max(60, "Email cannot exceed 60 characters")
      // .required("Email is required"),
    
      // mobileNo: Yup.string()
      // .matches(
      //   /^[6789]\d{9}$/,
      //   "Mobile number must start with 6,7, 8, or 9 and be exactly 10 digits"
      // )
      // .required("Mobile number is required"),
    
      dob:  Yup.date()
      .required("Date of Birth is required")
      .max(today, "Date of Birth cannot be in the future")
      .min(new Date(1900, 0, 1), "Date of Birth must be after 1900")
      .test(
        "age",
        `You must be at least ${minAge} years old`,
        (value) => value && value <= minDate
      )
      
  });


  // Form validation
  const validateForm = async () => {
    try {
      await validationSchema.validate({ ...formData , isPartnership , partners},{ abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages: Record<string, string> = {};
        err.inner.forEach((error) => {
          if (error.path) {
            errorMessages[error.path] = error.message;
          }
        });
       
        setErrors(errorMessages);
      }
      return false;
    }
  };


  // Form submission
  const handleSubmit = async () => {
  
      const isValid = await validateForm();
      if(!isValid){
          toast.error("Please fill all required fields correctly.", { position: "top-right", autoClose: 3000,});
          return;
        }
     
      
      if (isValid) {
       
        const formattedData = {
          departmentIdentifier: formData.district ,
          borderDepartmentIdentifier:formData.secondaryDistrict,
          departmentSelectType: formData.selectedDistrictType,
          applicantName: formData.applicantName ,
          validityUpTo: "3",
          isPartner: isPartnership === "Yes" ? true : false,
          partnerDetails: partners.length > 0 ? partners : existData?.partners || [],
          perAddress: {
          
            district: formData.currDistrict ,
               taluka: formData.currTaluka ,
            post: formData.currPost ,
            at: formData.currAt ,
           
          },
          regOffAddress: {
            
            district: formData.regDistrict ,
               taluka: formData.regTaluka ,
            post: formData.regPost,
            at: formData.regAt,
         
          },
          regEmailId: formData.registeredEmail ,
          mobileNo: formData.mobileNo ,
          dob: formData.dob 
        };
       
        
        
  
        try {
       
          setLoading(true);
                const res = await submitBasicDetailsforPanel(formattedData, token , existData?.applicationId);
        

          
       
                if (res.success === true) {
              
                  onNext(formData);
                 
                } else {
                  // alert(`${res.message}`);
                  toast.error(`${res.message}`, { position: "top-right", autoClose: 3000,});
                 
                }
              } catch (error) {
              
              } finally{
                setLoading(false);
              }
            
      }
    // }
    
  };



  const handleSelectChange = (name: string, option: any | any[] | null) => {
    const value = Array.isArray(option)
      ? option.map((item) => item.value)
      : option
      ? option.value
      : name === "district"
      ? "" // Reset district
      : []; // Reset secondaryDistrict

  
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      // Optional: reset secondaryDistrict if district changed
      ...(name === "district" ? { secondaryDistrict: [] } : {}),
    }));
  
    // Update border district options when district is selected
    if (name === "district") {

      const distOpt:any = districtOptions.find(
        (option) => option.value === value
      )
      
      


      const borderDistricts =
        borderDistrictData.find((d) => d?.District === distOpt?.label)?.["Border Districts"] || [];

  
        const borderOptions = borderDistricts.map((district) => ({
          label: district,
          value: district,
        }));

     

  
      setBorderDistrictOptions(borderOptions);
    }
  };

  const handleBorderDistrict = (name: string, option: any | any[] | null) => {



    

    const dist:any = districtOptions.filter(data=>
      option.some((opt:any)=> opt.label == data.label)
    )

  
 
    setFormData((prev) => ({
      ...prev,
      secondaryDistrict: dist.map(d => d.value),
    }))
   
  
  };

   useEffect(()=>{

   if( formData.district!="")
   {

    const distOpt:any = districtOptions.find(
      (option) => option.value === formData.district
    )
    
    

    const borderDistricts =
        borderDistrictData.find((d) => d?.District === distOpt?.label)?.["Border Districts"] || [];

  
        const borderOptions = borderDistricts.map((district) => ({
          label: district,
          value: district,
        }));


        setBorderDistrictOptions(borderOptions);
   }

  },[])

  
  const filteredDistrictOptions = districtOptions.filter(
    (option) => option.value !== formData.district
  );

  useEffect(() => {
  
    setIsPartnership(existData.isPartner == 'true' ? "Yes" : "No")
    if(existData && existData?.partnerDetails?.length>0)
    {
      setPartners(existData.partnerDetails)
      
    }
  },[]
  )



      const fetchSSODetails = async () =>{
        try{
          const res = await getSSODetailsByLogin(token);
          if (res.success && res.data){
            setPopulateData(res?.data)
         
          }
          else{
           
          }
        } catch (error){
        
          // alert("Failed to Load the Application Data")
          toast.error("Failed to Load the Application Data", { position: "top-right", autoClose: 3000,});
        }
      }



  return (
    <>
    {
      !isAllowed  ? 
      <div className="alert alert-danger" role="alert">
       You already have application or valid License. Note you can only apply/renew license before 2 month of expiry
        </div>
        :
        <div className="container">
      <div className="card">
        <div className="card-header">
          <h5 className="card-title">{language.enter_details}</h5>
        </div>
        <div className="card-body">
          <div className="mb-3">

            <label className="form-label">{formLanguage.applicant_name} ({language.applicant_name}) <span className="text-danger">*</span></label>
            <input type="text" className="form-control" name="applicantName"  value={formData.applicantName} maxLength={30} onChange={handleChange} />

            {errors.applicantName && <small className="text-danger">{errors.applicantName}</small>}
          </div>

          <div className="d-flex gap-4 mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="singleDistrict"
                      value="singleDistrict"
                      checked={formData.selectedDistrictType === "singleDistrict"}
                      onChange={handleRadioChange}
                    />
                    <label
                      className="form-label "
                      htmlFor="singleDistrict"
                    >
                      Single District
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="borderingDistricts"
                      value="multipleDistrict"
                      checked={formData.selectedDistrictType === "multipleDistrict"}
                      onChange={handleRadioChange}
                    />
                    <label
                      className="form-label "
                      htmlFor="borderingDistricts"
                    >
                      District with its Bordering Districts

                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="entireState"
                      value="entireState"
                      checked={formData.selectedDistrictType === "entireState"}
                      onChange={handleRadioChange}
                    />
                    <label
                      className="form-label "
                      htmlFor="entireState"
                    >
                      Entire State

                    </label>
                  </div>
                </div>

          <div className="mb-3">
            <label className="form-label">{formLanguage.district} ({language.district} )<span className="text-danger">*</span></label>
            {/* <input type="text" className="form-control" name="district" value={formData.district} onChange={handleChange} /> */}
            <CommonSelect
             options={[...districtOptions].sort((a, b) => a.label.localeCompare(b.label))}
              defaultValue={districtOptions.find(
                (option) => option.value === (existData?.department?.Department_Idetifier || formData.district || undefined) 
              )}
              onChange={(option) => handleSelectChange("district", option)}
            />
            {errors.district && <small className="text-danger">{errors.district}</small>}
          </div>

         {formData.selectedDistrictType=="multipleDistrict" && 
         <div className="mb-3">
            <label className="form-label">{formLanguage.secondaryDistrict} ({language.secondaryDistrict} )<span className="text-danger">*</span></label>
            {/* <input type="text" className="form-control" name="district" value={formData.district} onChange={handleChange} /> */}
            <Select
              isMulti
            options={[...borderDistrictOptions].sort((a, b) => a.label.localeCompare(b.label))}

                //   defaultValue={districtOptions.filter((option) =>
                //   formData.secondaryDistrict?.includes(option.value) // Match district names with Select values
                // )}
                value={districtOptions.filter((option) =>
                  formData.secondaryDistrict?.includes(option.value)
                )}

              // onChange={(option) => handleSelectChange("secondaryDistrict", option)}
              // onChange={(selectedOptions) =>
              //   setFormData((prev) => ({
              //     ...prev,
              //     secondaryDistrict: selectedOptions.map((opt) => districtOptions.find(data=>data.label == opt.value).value),
              //   }))
              // }
            
              onChange={(option) => handleBorderDistrict("secondaryDistrict", option)}

            />
            {errors.secondaryDistrict && <small className="text-danger">{errors.secondaryDistrict}</small>}
          </div>}

        
          <div className="mb-3">
            <label className="form-label">{formLanguage.partnership_firm} ({language.partnership_firm}) <span className="text-danger">*</span></label>
            <select className="form-control"  value={isPartnership} onChange={handleDropdownChange}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </select>
            {errors.isPartnership && <small className="text-danger">{errors.isPartnership}</small>}
            {errors.partners && <small className="text-danger">{errors.partners}</small>}
          </div>

          {isPartnership === "Yes" && (
            <>
            
              <Link to="#" className="btn btn-primary mb-3 btn-sm" data-bs-toggle="modal" data-bs-target="#partnerModal">
                + {language.add_partner}
              </Link>
              
              {partners.length > 0 && (

                <table className="table table-bordered mb-4">
                  <thead>
                  <h5>{formLanguage.partner_details} ({language.partner_details})</h5>
                    <tr><th>Sr No.</th><th>{language.name}</th><th>{language.age}</th><th>{language.address}</th><th></th></tr>
                  </thead>
                  <tbody>
                  
                    { partners.map((partner, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{partner.partnerName}</td>
                        <td>{partner.partnerAge}</td>
                        <td>{partner.partnerAddress}</td>
                        <td>
                          <button className="btn btn-danger btn-sm" onClick={() => deletePartner(index)}>🗑 {language.delete}</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                
              )}
               
            </>
          )}
      

<h5>{formLanguage.perAddress} ({language.perAddress})<span className="text-danger">*</span></h5>
    <CommonSelectTwo
             options={[...districtAddressOptions].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"
              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={districtOptions.find(option => option.label === formData.currDistrict) || null}
              value={formData.currDistrict}

              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("currDistrict", option , "currDistrictId" , "curr")}
              placeholder="District"
            />
{errors.currDistrict && <p className="text-danger">{errors.currDistrict}</p>}
 <CommonSelectTwo
            options={[...talukaOptionsCurr].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"

              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={talukaOptions.find(option => option.label === formData.currTaluka) || null}
              value={formData.currTaluka}


              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("currTaluka", option , "currTalukaId","curr")}
              placeholder="Taluka"
            />

{errors.currTaluka && <p className="text-danger">{errors.currTaluka}</p>}
<input
  type="text"
  className="form-control mb-3"
  placeholder={language.post}
  name="currPost"
  value={ formData.currPost}

  onChange={handleChange}
/>
{errors.currPost && <p className="text-danger">{errors.currPost}</p>}
          <input
            type="text"
            className="form-control mb-3"
            placeholder={language.address}
            name="currAt"
            value={formData.currAt}
            onChange={handleChange}
          />
{errors.currAt && <p className="text-danger">{errors.currAt}</p>}
          



   


 
   <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="sameAsCurrentAddress"
              checked={addressCheckboxChecked && formData.currAt === formData.regAt && formData.currTaluka === formData.regTaluka && formData.currDistrict === formData.regDistrict&& formData.regPost === formData.currPost}
              onChange={e => {
                setAddressCheckboxChecked(e.target.checked);
                if (e.target.checked) {
                  setFormData(prev => ({
                    ...prev,
                    regAt: prev.currAt,
                    regTaluka: prev.currTaluka,
                    regDistrict: prev.currDistrict,
                    regPost: prev.currPost
                  }));
                } else {
                  setFormData(prev => ({
                    ...prev,
                    regAt: "",
                    regTaluka: "",
                    regDistrict: "",
                    regPost: ""
                  }));
                }
              }}
            />
            <label className="form-check-label" htmlFor="sameAsCurrentAddress">
              Same as Permanent Address
            </label>
          </div>
<h5>{formLanguage.registered_office_address} ({language.registered_office_address})<span className="text-danger">*</span></h5>
    <CommonSelectTwo
             options={[...districtAddressOptions].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"
              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={districtOptions.find(option => option.label === formData.currDistrict) || null}
              value={formData.regDistrict}

              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("regDistrict", option , "regDistrictId" , "reg")}
              placeholder="District"
            />
{errors.regDistrict && <p className="text-danger">{errors.regDistrict}</p>}
    <CommonSelectTwo
            options={[...talukaOptionsReg].sort((a, b) => a.label.localeCompare(b.label))}
              className="mb-3"

              // value={districtOptions.find(option => option.value === selectData.district) || null}
              // value={talukaOptions.find(option => option.label === formData.currTaluka) || null}
              value={formData.regTaluka}


              // defaultValue={districtOptions.find(option => option.value === (existData?.department?.id || formData.departmentId)) || undefined}
              onChange={(option) => handleAddress("regTaluka", option , "regTalukaId","reg")}
              placeholder="Taluka"
            />
{errors.regTaluka && <p className="text-danger">{errors.regTaluka}</p>}
<input
  type="text"
  className="form-control mb-3"
  placeholder={language.post}
  name="regPost"
  value={formData.regPost}

  onChange={handleChange}
/>
{errors.regPost && <p className="text-danger">{errors.regPost}</p>}
<input
  type="text"
  className="form-control mb-3"
  placeholder={language.address}
  name="regAt"
  value={ formData.regAt}

  onChange={handleChange}
/>
{errors.regAt && <p className="text-danger">{errors.regAt}</p>}







 
<div className="row">
  <div className="col-md-4 mb-3">
    <label className="form-label">{formLanguage.registered_email_id} ({language.registered_email_id})<span className="text-danger">*</span></label>
    <input
      type="email"
      className="form-control"
      name="registeredEmail"
      value={userDetails.EMAIL}
      readOnly

      // onChange={handleChange}
/>
    {/* {errors.registeredEmail && <p className="text-danger">{errors.registeredEmail}</p>} */}
  </div>

  <div className="col-md-4 mb-3">
    <label className="form-label">{formLanguage.mobile} ({language.mobile})<span className="text-danger">*</span></label>
    <input
      type="tel"
      className="form-control"
      name="mobileNo"
      maxLength={10}
      value={userDetails.MOBILE}
      readOnly
      // onChange={handleChange}
/>
    {/* {errors.mobileNo && <p className="text-danger">{errors.mobileNo}</p>} */}
  </div>

  <div className="col-md-4 mb-3">
    <label className="form-label">{formLanguage.DOB} ({language.DOB})<span className="text-danger">*</span></label>
    <DatePicker
      // selected={selectedDate}
      onChange={(date: Date | null) => {
       
        setSelectedDate(date);
       setFormData((prev) => ({
  ...prev,
  dob: date ? format(date, "yyyy-MM-dd") : formData.dob,
}));
        setErrors((prev) => ({ ...prev, dob: "" })); // Clear error when selecting date
            }}
            selected={selectedDate || (existData?.dob ? existData.dob : null)}
            dateFormat="dd-MMM-yyyy"
            className="form-control"
            placeholderText="Select Date"
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={100}
            maxDate={today}
      />
    {errors.dob && <p className="text-danger">{errors.dob}</p>}
  </div>
</div>


          <button type="button" className="btn btn-primary" onClick={handleSubmit}>{language.next}</button>
        </div>
        <div className="modal fade" id="partnerModal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{formLanguage.add_partner_details} ({language.add_partner_details})</h4>
              <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
            <div className="modal-body pb-0">
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">
              {formLanguage.name} ({language.name} )<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="partnerName"
                value={partnerData.partnerName}
                onChange={handleInputChange}
                required
              />
              {errors.partnerName && <div className="text-danger">{errors.partnerName}</div>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">
              {formLanguage.age_in_year} ({language.age_in_year}) <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="partnerAge"
                value={partnerData.partnerAge}
                onChange={handleInputChange}
                required
              />
              {errors.partnerAge && <div className="text-danger">{errors.partnerAge}</div>}
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">
              {formLanguage.address} ({language.address}) <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="partnerAddress"
                value={partnerData.partnerAddress}
                onChange={handleInputChange}
                required
              />
              {errors.partnerAddress && <div className="text-danger">{errors.partnerAddress}</div>}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-white border me-2" data-bs-dismiss="modal">
          {language.can}
        </button>
        <button type="button" className="btn btn-primary"   onClick={addPartner}   {...(isValid ? { "data-bs-dismiss" : "modal" } : {})} >
          {language.save_partner}
        </button>
      </div>
            </form>
          </div>
        </div>
      </div>
      </div>
            <ToastContainer position="top-right" autoClose={3000} />

                  {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              Submitting...
            </span>
          </div>
        </div>
      )}
        </div>
    }
    </>
    
  );
};

export default BasicDetails;
